import { AllTeamsAccordion } from './AllTeamsAccordion';
import { GroupEntity } from '@backstage/catalog-model';
import { OverviewGuideCard } from './OverviewGuideCard';
import { RenovateChart } from './RenovateChart';
import { SecretsChart } from './SecretsChart';
import { useEntity } from '@backstage/plugin-catalog-react';
import { useTeamList } from '@internal/ui-common';
import { VulnerabilityChart } from './VulnerabilityChart';

import { Box, Grid } from '@material-ui/core';
import {
  CostScoreCardDepartment,
  CostScoreCardDepartmentVariant,
} from '@internal/backstage-plugin-zf-cost-scorecard';
import { InfoCard, Progress } from '@backstage/core-components';

export const Overview = () => {
  const { entity: departmentGroup } = useEntity<GroupEntity>();
  const { teams, isLoading } = useTeamList(departmentGroup);

  if (isLoading) {
    return <Progress />;
  }

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <OverviewGuideCard />
        </Grid>
      </Grid>
      {teams && (
        <Grid container>
          <Grid item xs={12} md={2}>
            <InfoCard title="Renovate" noPadding>
              <Box style={{ height: '15rem', padding: '16px' }}>
                <RenovateChart boardLabel="All Teams" teams={teams} />
              </Box>
            </InfoCard>
          </Grid>
          <Grid item xs={12} md={2}>
            <InfoCard title="Secrets" noPadding>
              <Box style={{ height: '15rem', padding: '16px' }}>
                <SecretsChart
                  boardLabel="All Teams"
                  teams={
                    departmentGroup.metadata.name === 'scalar'
                      ? undefined
                      : teams
                  }
                />
              </Box>
            </InfoCard>
          </Grid>
          <Grid item xs={12} md={8}>
            <InfoCard title="Vulnerabilities" noPadding>
              <Box style={{ height: '15rem', padding: '16px' }}>
                <VulnerabilityChart
                  teams={
                    departmentGroup.metadata.name === 'scalar'
                      ? undefined
                      : teams
                  }
                />
              </Box>
            </InfoCard>
          </Grid>
          <Grid item xs={12} md={4}>
            <CostScoreCardDepartment
              variant={CostScoreCardDepartmentVariant.Overview}
            />
          </Grid>
        </Grid>
      )}
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <AllTeamsAccordion teams={teams} />
        </Grid>
      </Grid>
    </>
  );
};
